module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs"
  }, [(_vm.bottom) ? _c('div', {
    ref: "tabsContainer",
    class: ['tab-content', {
      'card-block': _vm.card
    }]
  }, [_vm._t("default"), _vm._v(" "), (!_vm.tabs || !_vm.tabs.length) ? _vm._t("empty") : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'card-header': _vm.card
    }
  }, [_c('ul', {
    class: ['nav', 'nav-' + _vm.navStyle, _vm.card ? 'card-header-' + _vm.navStyle : null]
  }, [_vm._l((_vm.tabs), function(tab, index) {
    return _c('li', {
      staticClass: "nav-item"
    }, [(!tab.headHtml) ? _c('a', {
      class: ['nav-link', {
        small: _vm.small,
        active: tab.localActive,
        disabled: tab.disabled
      }],
      attrs: {
        "href": tab.href
      },
      domProps: {
        "innerHTML": _vm._s(tab.title)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.setTab(index)
        }
      }
    }) : _c('div', {
      class: ['tab-head', {
        small: _vm.small,
        active: tab.localActive,
        disabled: tab.disabled
      }],
      domProps: {
        "innerHTML": _vm._s(tab.headHtml)
      }
    })])
  }), _vm._v(" "), _vm._t("tabs")], 2)]), _vm._v(" "), (!_vm.bottom) ? _c('div', {
    ref: "tabsContainer",
    class: ['tab-content', {
      'card-block': _vm.card
    }]
  }, [_vm._t("default"), _vm._v(" "), (!_vm.tabs || !_vm.tabs.length) ? _vm._t("empty") : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04c5a05d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/tabs.vue
// module id = 223
// module chunks = 0